import { useCallback, useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

function useGetResponseMarketing() {
  const authCtx = useContext(AuthContext);
  const { sendRequest } = useHttp();

  const authHeaders = useCallback(
    () => ({
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + authCtx.token,
    }),
    [authCtx.token]
  );

  const getStatus = useCallback(async () => {
    return sendRequest({
      url: '/api/v1/getresponse-marketing/status',
      method: 'GET',
      headers: authHeaders(),
    });
  }, [sendRequest, authHeaders]);

  const getCampaigns = useCallback(async () => {
    return sendRequest({
      url: '/api/v1/getresponse-marketing/campaigns',
      method: 'GET',
      headers: authHeaders(),
    });
  }, [sendRequest, authHeaders]);

  const patchCampaign = useCallback(
    async (entertainmentId, campaignIds) => {
      const ids = Array.isArray(campaignIds)
        ? campaignIds
        : campaignIds === '' || campaignIds == null
          ? []
          : [campaignIds];
      return sendRequest({
        url: `/api/v1/getresponse-marketing/entertainment/${entertainmentId}/campaign`,
        method: 'PATCH',
        headers: authHeaders(),
        body: { campaignIds: ids },
      });
    },
    [sendRequest, authHeaders]
  );

  const postSync = useCallback(
    async entertainmentId => {
      return sendRequest({
        url: '/api/v1/getresponse-marketing/sync',
        method: 'POST',
        headers: authHeaders(),
        body: entertainmentId ? { entertainmentId } : {},
      });
    },
    [sendRequest, authHeaders]
  );

  return { getStatus, getCampaigns, patchCampaign, postSync };
}

export default useGetResponseMarketing;
